import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
export function MartialArtsNearMeWhatYouLearn() {
  return <section className="py-24 bg-off-white" data-id="element-2497">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2498">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-2499">
          <div data-id="element-2500">
            <h2 className="text-4xl md:text-5xl text-ink mb-8" data-id="element-2501">
              What You'll Learn
            </h2>
            <ul className="flex flex-col gap-4" data-id="element-2502">
              {['Core martial arts stances, blocks, and strikes', 'Dynamic kicking techniques unique to Taekwondo', 'How to set and achieve long-term goals', 'Respect, courtesy, and self-control', 'Improved physical coordination and flexibility'].map((item, idx) => <li key={idx} className="flex items-start gap-4 text-lg text-gray-warm" data-id="element-2503">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-2504" />
                  <span data-id="element-2505">{item}</span>
                </li>)}
            </ul>
            <div className="mt-10" data-id="element-2506">
              <Link to="/SignMeUp" className="btn-primary" data-id="element-2507">
                Find the Right Class or Program
              </Link>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-[400px]" data-id="element-2508">
            <img src="https://images.unsplash.com/photo-1599058917212-d750089bc07e?auto=format&fit=crop&w=1200&q=80" alt="Training at Storm Taekwondo" className="block w-full h-full object-cover" data-id="element-2509" />
          </div>
        </div>
      </div>
    </section>;
}